<template>
  <div>
    <!--<div align="left">-->
      <!--<el-button type="primary" icon="el-icon-circle-plus">添加新的回收站</el-button>-->
    <!--</div>-->


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="id"
        label="编号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="名字"
        width="100">
      </el-table-column>

      <!--<el-table-column-->
        <!--prop="weight1"-->
        <!--label="常规1柜"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="weight2"-->
        <!--label="常规2柜"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="weight3"-->
        <!--label="常规3柜"-->
        <!--width="100">-->
      <!--</el-table-column>-->
      <!--<el-table-column-->
        <!--prop="weight4"-->
        <!--label="利器柜"-->
        <!--width="100">-->
      <!--</el-table-column>-->

      <el-table-column
        prop="addr"
        label="地址"
        width="300">
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        width="100">
        <template slot-scope="scope">
          <el-tag
            :type="(scope.row.state&2)===2 ? 'success' : 'danger'"
            disable-transitions>{{(scope.row.state&2)===2?'在线':'不在线'}}</el-tag>
        </template>

      </el-table-column>
      <el-table-column
        prop="lastDisconnectTime"
        label="最后断线时间"
        width="140">
      </el-table-column>
      <el-table-column
        prop="ip"
        label="最后登陆IP"
        width="130">
      </el-table-column>
      <el-table-column
        prop="sn"
        label="SN"
        width="130">
      </el-table-column>
      <el-table-column
        prop="creator"
        label="注册者"
        width="130">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="showData(scope.$index, tableData)"
            size="mini" type="success" >
            明细
          </el-button>
          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="tableData[scope.$index].state&1==1?'danger':'success'" >-->
            <!--{{tableData[scope.$index].state&1==1?"停用":"启用"}}-->
          <!--</el-button>-->
          <!--<el-button-->
            <!--@click.native.prevent="changeEnable(scope.$index, tableData)"-->
            <!--size="mini" :type="tableData[scope.$index].state&2==2?'danger':'success'" >-->
            <!--{{tableData[scope.$index].state&2==2?"开始维护":"维护完成"}}-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      showData(index,rows){
        // const params = { id:rows[index].id};
        // let routeData = $this.$router.resolve({
        //   path: "/m/terminalData",
        //   query: params,
        // });
        this.$router.push({name:'TerminalData',params:{ id:rows[index].id}})
        //window.open(routeData.href, '_blank');
      },
      changeEnable(index, rows) {
        if (rows[index].state&1==1){
          rows[index].state^=1
        }else{
          rows[index].state|=1
        }
      },
      handleSizeChange(e){
      this.pageSize=e;
        window.ws.Call("W2S_UserList",this.page,this.pageSize);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_UserList",this.page,this.pageSize);
      }
    },
    mounted() {
      let $this=this;
      window.ws.AddFunc("S2W_TerminalInfoListRes",function (code,err,currentPage,total,list) {
        console.log("S2W_TerminalInfoListRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_TerminalInfo",$this.page,$this.pageSize);
    },
    data() {
      return {
        page:1,
        pageSize:10,
        total:0,
        tableData: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/terminalManager.vue